<script setup lang="ts">
import { computed } from 'vue';
import { cn } from '@/lib/cn';

const props = defineProps<{
  name?: string;
  size?: 'sm' | 'md' | 'lg';
  class?: string;
}>();

const sizeClass = computed(() => {
  switch (props.size) {
    case 'sm':
      return 'h-7 w-7 text-[11px]';
    case 'lg':
      return 'h-12 w-12 text-[16px]';
    default:
      return 'h-9 w-9 text-[13px]';
  }
});

const initials = computed(() => {
  const n = (props.name ?? '').trim();
  if (!n) return '?';
  const parts = n.split(/\s+/);
  if (parts.length === 1) return n.slice(0, 2).toUpperCase();
  return `${parts[0]?.[0] ?? ''}${parts[parts.length - 1]?.[0] ?? ''}`.toUpperCase();
});

const hue = computed(() => {
  const n = props.name ?? '';
  let h = 0;
  for (let i = 0; i < n.length; i++) h = (h * 31 + n.charCodeAt(i)) % 360;
  return h;
});

const style = computed(() => ({
  backgroundImage: `linear-gradient(135deg, hsl(${hue.value} 85% 65%), hsl(${(hue.value + 35) % 360} 80% 50%))`,
}));
</script>

<template>
  <span
    :class="cn('inline-flex items-center justify-center rounded-full font-semibold text-white shrink-0', sizeClass, props.class)"
    :style="style"
    :aria-label="name"
  >
    {{ initials }}
  </span>
</template>
